import React from 'react'

const Contact = (props) => (
    <section id="contact">
        <div className="inner">
            <section>
                <form method="post" name="contact" data-netlify="true" data-netlify-honeypot="bot-field">
                     <p className ="hidden-form">
                        <label>Don’t fill this out if you're human: <input name="bot-field" /></label>
                    </p>
                    <div className="field half first">
                        <label htmlFor="name">Nom</label>
                        <input type="text" name="name" id="name" />
                    </div>
                    <div className="field half">
                        <label htmlFor="email">Email</label>
                        <input type="text" name="email" id="email" />
                    </div>
                    <div className="field">
                        <label htmlFor="message">Message</label>
                        <textarea name="message" id="message" rows="6"></textarea>
                    </div>
                    <ul className="actions">
                        <li><button className="special">Envoyer</button></li>
                        <li><input type="reset" value="Effacer" /></li>
                    </ul>
                </form>
            </section>
            <section className="split">
                <section>
                    <div className="contact-button">
                        <a href="https://www.clicrdv.com/233-cabinet-garnier?clicrdv_widget=1&widget_width=600&websource=https%3A%2F%2Fwww.reflexologie-olonne.fr%2Fcontact.html"><button>prendre RDV maintenant</button> </a>
                    </div>
                </section>
                <section>
                    <div className="contact-method">
                        <span className="icon alt fa-phone"></span>
                        <h3>Téléphone</h3>
                        <span>06.84.89.60.82</span>
                    </div>
                </section>
                <section>
                    <div className="contact-method">
                        <span className="icon alt fa-home"></span>
                        <h3>Adresse</h3>
                        <span>La Grenière<br />
                        Aubigny <br />
                        85430 Aubigny-les Clouzeaux<br /></span>
                        <a href="https://www.google.com/maps/place/Anne+GARNIER+R%C3%A9flexologue/@46.5311371,-1.7714428,11z/data=!4m8!1m2!2m1!1sanne+garnier!3m4!1s0x0:0x8bf6281c58a33a1f!8m2!3d46.5694825!4d-1.4665461">Google Maps</a>
                    </div>
                </section>
            </section>
        </div>
    </section>
)

export default Contact



// WEBPACK FOOTER //
// ./src/components/Contact.js